'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var styledComponents = require('./styled-components.js');

var PrimaryButton = function (props) {
    var title = props.title, onClick = props.onClick, _a = props.disabled, disabled = _a === void 0 ? false : _a, icon = props.icon, dataTestId = props["data-testid"], _b = props.className, className = _b === void 0 ? '' : _b;
    return (React__default.createElement(styledComponents.StyledButton, { onClick: onClick, disabled: disabled, size: 'medium', "data-testid": dataTestId, className: className, startIcon: icon }, title));
};

module.exports = PrimaryButton;
